/*
 * @Author: your name
 * @Date: 2019-11-08 15:29:08
 * @LastEditTime: 2019-12-03 18:23:58
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \source\src\components\onlineMap\model\CollectFolderJs.js
 */

 import AxiosConfig from "../../../config/AxiosConfigJs.js";

 import { CustomArray } from "../../../utility/common/CustomArray.js";
 import {GuidUtility } from "../../../utility/common/GuidUtility.js";


export class UserCollectFolder
{   
    constructor()
    {   
        this.id=GuidUtility.getGuid();
        this.name=null;
        this.userId=null;
        this.parentId=null;
        this.collectItems=null;
        this.subFolders=null;
        this.createTime=null;
        //界面用属性：是否为焦点记录
        this.focusStatus=false;
    }


    copyBasicInfo()
    {   
        let newObject=new UserCollectFolder();
        newObject.id=this.id;
        newObject.name=this.name;
        newObject.userId=this.userId;
        newObject.parentId=this.parentId;
        newObject.createTime=this.createTime;
        newObject.focusStatus=this.focusStatus;
        
        return newObject;
    }


    
    //1.2方法：参数含请求路径，请求成功，和失败的回调函数
    create(url, succeedCallback, errorCallback) {
        AxiosConfig.platform
            .post(url, this)
            .then(function (response) {
                var responseResult = null;
                //判断是否有响应结果
                if (response) {
                    responseResult = response.data;
                }
                //如果请求成功就将结果通过回调函数反馈
                if (succeedCallback) {
                    succeedCallback(responseResult);
                }
            })
            .catch(function (error) {

                if (errorCallback) {
                    errorCallback(error);
                }
            });
    }

    //update  编辑
    update(url, succeedCallback, errorCallback) {
        AxiosConfig.platform
            .put(url, this)
            .then(function (response) {
                var responseResult = null;
                if (response != null) {
                    responseResult = response.data;
                }
                if (succeedCallback) {
                    succeedCallback(responseResult);
                }

            })

            .catch(function (error) {

                if (errorCallback) {
                    errorCallback(error);
                }
            });
    }

    //将json串转化成对象
    static fromJson(jsonObject) {
        let folder = null;
        //判断是否传参，为传参返回null
        if (!jsonObject) return folder;

        folder = new UserCollectFolder();
        folder.id = jsonObject.id;
        folder.name = jsonObject.name;
        folder.parentId=jsonObject.parentId;
        folder.userId=jsonObject.userId;
        folder.createTime=jsonObject.createTime;

        if(jsonObject.collectItems)
        {
            folder.collectItems=UserCollectItems.fromJsons(jsonObject.collectItems);
        }

        return folder;
    }




}


export class UserCollectFolders extends CustomArray
{   
    constructor()
    {
        super();
    }

    findById(id)
    {   
        let findItem=null;

		let tempItem=null;
		for(let tempIndex=0;tempIndex<this.objects.length;tempIndex++)
		{	
			tempItem=this.objects[tempIndex];
			if(tempItem && tempItem.id===id)
			{	
				findItem=tempItem;
				break;
			}
        }
        
        return findItem;
    }

    findIndexById(id)
	{	
		let findIndex=-1;

		let tempItem=null;
		for(let tempIndex=0;tempIndex<this.objects.length;tempIndex++)
		{	
			tempItem=this.objects[tempIndex];
			if(tempItem && tempItem.id===id)
			{	
				findIndex=tempIndex;
				break;
			}
		}

		return findIndex;
	}
    

    //删除
    static deleteMulti(idArray, url, succeedCallback, errorCallback) {
        //let qsParam=qs.stringify({ ids: idArray }, { indices: false });
        let qsParam = idArray.toString();

        AxiosConfig.platform
            .get(url, { params: { ids: qsParam,random: Math.random() } })
            .then(function (response) {
                var responseResult = null;
                if (response != null) {
                    responseResult = response.data;
                }
                if (succeedCallback) {
                    succeedCallback(responseResult);
                }
            })

            .catch(function (error) {
                if (errorCallback) {

                    errorCallback(error);
                }

            });
    }


    //通过筛选条件查找
    static selectByFilter(filter, url, succeedCallback, errorCallback) {

        AxiosConfig.platform
            .post(url, filter)
            .then(function (response) {
                var responseResult = null;
                if (response != null && response.data) {
                    responseResult = response.data.data;
                }
                if (succeedCallback) {
                    succeedCallback(responseResult);
                }
            })

            .catch(function (error) {

                if (errorCallback) {
                    errorCallback(error);
                }
            });
    }

    /**
     * 通过筛选条件查找总数
     * @param {*} filter 
     * @param {*} url 
     * @param {*} succeedCallback 
     * @param {*} errorCallback 
     */
    static selectCountByFilter(filter, url, succeedCallback, errorCallback) {
        AxiosConfig.platform
            .post(url, filter)
            .then(function (response) {
                var responseResult = null;
                if (response != null && response.data) {
                    responseResult = response.data.data;
                }
                if (succeedCallback) {
                    succeedCallback(responseResult);
                }
            })

            .catch(function (error) {

                if (errorCallback) {
                    errorCallback(error);
                }
            });
    }


    static fromJsons(jsonObjects) {
        let folders = new UserCollectFolders();
        if (!jsonObjects) return folders;
        
        let tempJsonItem = null;
        let tempFolder = null;
        for (let tempIndex = 0; tempIndex < jsonObjects.length; tempIndex++) {
            tempJsonItem = jsonObjects[tempIndex];
            tempFolder = UserCollectFolder.fromJson(tempJsonItem);
            if (!tempFolder) continue;
            
            tempFolder.index=tempIndex+1;

            folders.push(tempFolder);
        }

        return folders;
    }
    
}

export class UserCollectItem
{   
    constructor()
    {   
        this.id=GuidUtility.getGuid();
        this.name=null;
        this.userId=null;
        this.folderId=null;
        this.createTime=null;

        this.type=null;
        
        //收藏内容
        this.content=null;
        
        this.checked=false;
    }

    copyBasicInfo()
    {   
        let newObject=new UserCollectItem();
        newObject.id=this.id;
        newObject.name=this.name;
        newObject.userId=this.userId;
        newObject.folderId=this.folderId;
        newObject.createTime=this.createTime;
        newObject.type=this.type;
        newObject.content=this.content;
        
        return newObject;
    }
    
    //1.2方法：参数含请求路径，请求成功，和失败的回调函数
    create(url, succeedCallback, errorCallback) {
        AxiosConfig.platform
            .post(url, this)
            .then(function (response) {
                var responseResult = null;
                //判断是否有响应结果
                if (response) {
                    responseResult = response.data.data;
                }
                //如果请求成功就将结果通过回调函数反馈
                if (succeedCallback) {
                    succeedCallback(responseResult);
                }
            })
            .catch(function (error) {

                if (errorCallback) {
                    errorCallback(error);
                }
            });
    }

    //update  编辑
    update(url, succeedCallback, errorCallback) {
        AxiosConfig.platform
            .put(url, this)
            .then(function (response) {
                var responseResult = null;
                if (response != null) {
                    responseResult = response.data;
                }
                if (succeedCallback) {
                    succeedCallback(responseResult);
                }

            })

            .catch(function (error) {

                if (errorCallback) {
                    errorCallback(error);
                }
            });
    }
    
    
    //将json串转化成对象
    static fromJson(jsonObject)
    {   
        let item = null;
        //判断是否传参，为传参返回null
        if (!jsonObject) return item;

        item = new UserCollectItem();
        item.id = jsonObject.id;
        item.name = jsonObject.name;
        item.folderId=jsonObject.folderId;
        item.type=jsonObject.type;
        item.userId=jsonObject.userId;
        item.createTime=jsonObject.createTime;
        item.content=jsonObject.content;
        
        return item;

    }

}


export class UserCollectItems extends CustomArray
{   
    constructor()
    {   
        super();
    }


    findIndexById(id)
	{	
		let findIndex=-1;

		let tempItem=null;
		for(let tempIndex=0;tempIndex<this.objects.length;tempIndex++)
		{	
			tempItem=this.objects[tempIndex];
			if(tempItem && tempItem.id===id)
			{	
				findIndex=tempIndex;
				break;
			}
		}

		return findIndex;
    }
    

    //删除
    static deleteMulti(idArray, url, succeedCallback, errorCallback) {
        //let qsParam=qs.stringify({ ids: idArray }, { indices: false });
        let qsParam = idArray.toString();

        AxiosConfig.platform
            .get(url, { params: { ids: qsParam,random: Math.random() } })
            .then(function (response) {
                var responseResult = null;
                if (response != null) {
                    responseResult = response.data;
                }
                if (succeedCallback) {
                    succeedCallback(responseResult);
                }
            })

            .catch(function (error) {
                if (errorCallback) {

                    errorCallback(error);
                }

            });
    }


    //通过筛选条件查找
    static selectByFilter(filter, url, succeedCallback, errorCallback) {

        AxiosConfig.platform
            .post(url, filter)
            .then(function (response) {
                var responseResult = null;
                if (response != null && response.data) {
                    responseResult = response.data.data;
                }
                if (succeedCallback) {
                    succeedCallback(responseResult);
                }
            })

            .catch(function (error) {

                if (errorCallback) {
                    errorCallback(error);
                }
            });
    }

    static fromJsons(jsonObjects)
    {   
        let items = new UserCollectFolders();
        if (!jsonObjects) return items;
        
        let tempJsonItem = null;
        let tempItem = null;
        for (let tempIndex = 0; tempIndex < jsonObjects.length; tempIndex++) {
            tempJsonItem = jsonObjects[tempIndex];
            tempItem = UserCollectItem.fromJson(tempJsonItem);
            if (!tempItem) continue;
            
            tempItem.index=tempIndex+1;

            items.push(tempItem);
        }

        return items;
    }

}

export const UserCollectItemType=
{   
    point:"point",

    polyline:"polyline",

    polygon:"polygon",
    
}


export class UserCollectFolderFilter
{   
    constructor()
    {   
        this.useName=false;
        this.name=null;

        this.useUserId=false;

        this.userId=null;
        

        this.useCollectItemFilter=false;

        this.collectItemFilter=null;

        this.usePagination = false;

        this.paginationStart = 0;

        this.paginationCount = 10;


    }



}


export class UserCollectItemFilter
{   
    constructor()
    {   
        this.useFolderId=false;
        this.folderId=null;
        
    }



}

export class UserCollectItemFilterResult
{   
    constructor()
    {   
        this.collectItemCount=-1;
        this.filterCollectItemCount=-1;
        this.filterCollectItems=null;
    }

    
    static fromJson(jsonObject) {
        let filterResult = null;
        if (!jsonObject) return filterResult;

        filterResult = new UserCollectItemFilterResult();
        //总条数
        filterResult.collectItemCount = jsonObject.collectItemCount;
        //筛选出的符合条件的条数
        filterResult.filterCollectItemCount = jsonObject.filterCollectItemCount;
        //两条对象的数组
        filterResult.filterCollectItems = UserCollectItems.fromJsons(jsonObject.filterCollectItems);
        
        return filterResult;
    }
    
}

export class UserCollectFolderFilterResult
{   
    constructor()
    {   
        this.folderCount=-1;
        this.filterFolderCount=-1;
        this.filterFolders=null;
    }


    static fromJson(jsonObject) {
        let filterResult = null;
        if (!jsonObject) return filterResult;

        filterResult = new UserCollectFolderFilterResult();
        //总条数
        filterResult.folderCount = jsonObject.folderCount;
        //筛选出的符合条件的条数
        filterResult.filterFolderCount = jsonObject.filterFolderCount;
        //两条对象的数组
        filterResult.filterFolders = UserCollectFolders.fromJsons(jsonObject.filterFolders);
        
        return filterResult;
    }



}